// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card[data-v-67b9a2c0] {\n  overflow-x:hidden;\n}\n", ""]);
// Exports
module.exports = exports;
